import { defineStore } from 'pinia';
import type { ICompany } from '~/shared/interfaces/account';
import type { ICartProduct } from "~/shared/interfaces/cart";
import type { TIndividual, TRecipientType, IChoiceOfDelivery } from '~/shared/interfaces/order';
import type { IUser } from '~/shared/interfaces/user';
import type {IAddress} from "~/shared/interfaces/account";

interface CityProduct {
  [key: string]: {
    products: ICartProduct[]
    cityName: string
    productsPrice: number
  }
}

interface IOderState {
  isOpen: boolean
  cityProductsOrder: CityProduct
  choiceOfDelivery: IChoiceOfDelivery
  individualUser: TIndividual
  selectedCompany?: ICompany | null
  addressesList: IAddress[] | []
  nameAddress: string,
  selectedAddressesDelivery: []
  modalData: {
    name?: string
    title?: string
    subText?: string
    buttonText?: string
    cityName?: string
    citySlug?: string
    type?: string
  },
  successOrderNum: string
  successOrderPrice: string
}

const useOrderStore = defineStore('orderPage', {
  state: (): IOderState => ({
    isOpen: false,
    cityProductsOrder: {},
    choiceOfDelivery: {
      deliveryData: {
        payerType: 'entity',
        first_name: '',
        last_name: '',
        phone: '',
        companyId: null,
        comment: '',
        cities: []
      },
      cityData: {}
    },
    selectedCompany: null,
    individualUser: {
      firstName: '',
      lastName: '',
      phone: '',
    },
    addressesList: [],
    nameAddress: '',
    selectedAddressesDelivery: [],
    modalData: {
      title: '',
      name: '',
      buttonText: ''
    },
    successOrderNum: '',
    successOrderPrice: ''
  }),
  getters: {
    getModalIsOPen(state: IOderState) {
      return state.isOpen;
    },
    getModal(state: IOderState) {
      return state.modalData;
    },

  },
  actions: {
    modalIsOpen(isOpen: boolean, data?: { title: string, name: string, buttonText: string }) {
      if (data?.title) {
        this.modalData = data
      }
      this.isOpen = isOpen
    },
    setIndividual(user: TIndividual) {
      this.individualUser = user;
    },
    setSelectedCompany(company?: ICompany) {
      this.selectedCompany = company;
    },
    setPayerType(payer: TRecipientType) {
      this.choiceOfDelivery.deliveryData.payerType = payer;
    },
    setMainAddress(addressId: string) {
      this.addressesList.forEach(address => {
        address.isMain = address.id == addressId;
      })
    },
    setSuccessOrderNum(orderNum: string) {
      this.successOrderNum = orderNum
    },
    setSuccessOrderPrice(orderPrice: string) {
      this.successOrderPrice = orderPrice
    },
    setResetSelectedDelivery(citySlug: string) {
      this.choiceOfDelivery.cityData[citySlug].deliveryInfo = {
        address: null,
        desc: null,
        workMode: null,
        selected: false
      }
      this.choiceOfDelivery.cityData[citySlug].deliveryType = {
        active: false,
        buttonActive: false,
        description: '',
        icon: null,
        title: '',
        type: '',
      }
    }
  },
})
export default useOrderStore;
